import { useEffect } from 'react'
import Entity from '../types/Entity'

interface useInitSearchProps {
  limit: number,
  enableSearch: boolean
  includedRows: Array<Entity>
  excludedRows: Array<Entity>
  setShowSearch: (showSearch: boolean) => void
}

const useInitSearch = (props: useInitSearchProps) => {
  useEffect(() => {
    const showSearch: boolean = props.enableSearch && (props.includedRows.length > props.limit || props.excludedRows.length > props.limit)
    props.setShowSearch(showSearch)
  }, [props.includedRows, props.excludedRows])
}

export default useInitSearch
